// @flow
import type { Location, RouterHistory } from "react-router-dom";
import type { Dispatch } from "redux";
import { find } from "lodash";
import { triggerRefreshSession } from "@tvg/sh-lib-account-wallet/src/utils/mobileUtils";
import { modalHashMap } from "../Hashes";
import { closeAllModals } from "../../actions/modals";

export const interceptor = (
  previousLocation?: Location,
  currentLocation: Location,
  dispatch: Dispatch<any>,
  history: RouterHistory,
  isLogged: boolean,
  isAccountCompliant?: boolean,
  myBetsStandaloneToggle?: boolean
) => {
  if (currentLocation.hash) {
    const url = `${currentLocation.pathname}${currentLocation.search}`;
    const hash = find(
      modalHashMap(
        dispatch,
        history,
        url,
        isLogged,
        isAccountCompliant,
        myBetsStandaloneToggle
      ),
      (h) => h.hash === currentLocation.hash
    );
    if (hash) {
      hash.call();
    }
  } else if (previousLocation?.hash) {
    dispatch(closeAllModals());
  }

  if (
    previousLocation &&
    (previousLocation.pathname !== currentLocation.pathname ||
      previousLocation.search !== currentLocation.search ||
      previousLocation.hash !== currentLocation.hash)
  ) {
    triggerRefreshSession();
  }
};

export default {
  interceptor
};
